export default __webpack_public_path__ + "static/media/MEETING-new-logo-IST-bianco.0a063a09.png";